import { Action } from "redux";

export const CHANGE_UPPER_LIMIT_ACTION = "CHANGE_UPPER_LIMIT_ACTION";

export interface ChangeUpperLimitAction extends Action {
    upperLimit: number;
}

export const changeUpperLimitAction = (upperLimit: number): ChangeUpperLimitAction => ({
    type: CHANGE_UPPER_LIMIT_ACTION,
    upperLimit: upperLimit,
});
